/*
Poornima 09/19/2022 2701012930 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
saikrishna 11/04/2022 2701012930 Added props
Sohel 11/08/2022 2701012930 prepopulate formula code
Akhila 11/21/2022 2701012930 addAccount props pass
Sohel 11/21/2022 2701012930 props pass
Prakash 11/22/2022 2701012930 Added conditional card spacing.
Sohel 11/22/2022 2701012930 formula Rule Group Table changes
Ashraf 15/16/2022 2701012930 fixed role access
Sohel  04/25/2023 2701127043 Added Data Calculation Field
*/
import React, {useEffect, useState} from 'react';
import RuleGroupSearch from './RuleGroupSearch';
import {ResetStatus as resetStatus} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {useDispatch} from 'react-redux';

const SearchRuleGroupContainer = ({
  card,
  handleClose,
  dataReset,
  setValue,
  setFieldRowData,
  setBreCode,
  setResetData,
  setUsageState,
  usageState,
  setFormulaRuleGroupCode,
  setRowSelected,
  addAccount,
  setOpenFormulaCode,
  setSelectedFormulaCode,
  addAction,
  fieldRowData,
  setEditExisting,
  isReports,
  mapFields,
  setTempSelectedRows = () => {},
  tempSelectedRows,
  handleDataCalculationFields,
  reportFieldsDeleteIdsRef,
  workqueueFieldsDeletedIdsRef,
  isWorkQueue,
  setReportSelectedRows,
  setReportFieldValue,
  reportSelectedRows,
  isReportsFilter,
  rules,
  setRules,
  setInitialValues,
  filterValues,
  filterMethodRef,
  resultExpCondition,
  handleFilterClose,
  addAccountUpdate,
  selectedGlobalField,
}) => {
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchData, setSearchData] = useState({});
  useEffect(() => {
    dispatch(resetStatus());
  }, []);

  return (
    <>
      <RuleGroupSearch
        setValue={setValue}
        setFieldRowData={setFieldRowData}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        searchData={searchData}
        setSearchData={setSearchData}
        setBreCode={setBreCode}
        setResetData={setResetData}
        dataReset={dataReset}
        handleClose={handleClose}
        setUsageState={setUsageState}
        usageState={usageState}
        setRowSelected={setRowSelected}
        addAccount={addAccount}
        setOpenFormulaCode={setOpenFormulaCode}
        setSelectedFormulaCode={setSelectedFormulaCode}
        addAction={addAction}
        card={card}
        setEditExisting={setEditExisting}
        fieldRowData={fieldRowData}
        isReports={isReports}
        mapFields={mapFields}
        setTempSelectedRows={setTempSelectedRows}
        tempSelectedRows={tempSelectedRows}
        handleDataCalculationFields={handleDataCalculationFields}
        setReportSelectedRows={setReportSelectedRows}
        reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
        workqueueFieldsDeletedIdsRef={workqueueFieldsDeletedIdsRef}
        isWorkQueue={isWorkQueue}
        setReportFieldValue={setReportFieldValue}
        reportSelectedRows={reportSelectedRows}
        isReportsFilter={isReportsFilter}
        rules={rules}
        setRules={setRules}
        setInitialValues={setInitialValues}
        filterValues={filterValues}
        filterMethodRef={filterMethodRef}
        resultExpCondition={resultExpCondition}
        handleFilterClose={handleFilterClose}
        dialog={true}
        addAccountUpdate={addAccountUpdate}
        selectedGlobalField={selectedGlobalField}
      />
    </>
  );
};
export default SearchRuleGroupContainer;
